import { selectReferenceNode } from '@newStore/documentUI/transformContent/referenceGroupSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';

const PRO_NEWSLETTER_EVENT: BuildingBlockNodeConfig = {
  nodeSelector: selectReferenceNode,
  validationRules: [],
  information: {
    single: 'Kalenderitem',
    plural: 'Kalenderitems',
    ribonIcon: require('../../../../../img/buildingBlocks/EVENT.svg'),
  },
  buildingBlocks: [],
  edit: [],
  isCollapsible: false,
  isNotDraggable: true, // the sync orders the items by date.
  onNewNodeDropped: {
    openAside: false,
  },
  readOnlyNode: true,
};

export default PRO_NEWSLETTER_EVENT;
